import React, { ChangeEvent, useContext, useState } from 'react';
import { Components } from './styled';
import { ReactComponent as AccessLinkIcon } from '../../../assets/icons/icon-grey-check-square-offset.svg';
import { getFileExtension } from '../../../utils/s3/utils';
import { getAuthorUploadFileName } from '../../../api/author/utils';
import { ActivityIndicatorContext } from '../../../providers/ActivityIndicatorProvider/context';
import { uploadPublicFile } from '../../../utils/s3';
import { PUBLIC_BUCKET } from '../../../defines';
import ProjectTextField from '../ProjectTextField';

const ProjectImageField = ({
  imagePath,
  setImagePath,
  id,
}: {
  imagePath: string | undefined;
  setImagePath: (path: string | undefined) => void;
  id: string;
}) => {
  const { setIsLoading } = useContext(ActivityIndicatorContext);
  const [imageUploadProgress, setImageUploadProgress] = useState<number | undefined>(undefined);
  const [imageUrl, setImageUrl] = useState<string | undefined>();

  const onUploadPublicFile = async (e: ChangeEvent<HTMLInputElement> | undefined, fileName: string, path: string) => {
    setIsLoading(true);
    const file = e?.target?.files?.[0];
    // @ts-ignore
    const newFile = new File([file], fileName, { type: file?.type });
    if (newFile) {
      if (e && e.target && e.target.value) {
        e.target.value = '';
      }

      await uploadPublicFile(newFile, path, (progress) => {
        setImageUploadProgress(progress);
        if (progress === 100) {
          setImagePath(path);
          const link = PUBLIC_BUCKET + path;
          setImageUrl(link);
          setImageUploadProgress(undefined);
        }
      });
    }
    setIsLoading(false);
  };

  const selectHandlerForImageFile = async (event: React.ChangeEvent<HTMLInputElement> | undefined) => {
    const file = event?.target?.files?.[0];

    if (file) {
      const extension = getFileExtension(file);
      const fileName = getAuthorUploadFileName();
      const path = 'images/'.concat(fileName).concat('.', extension || '');
      await onUploadPublicFile(event, fileName, path);
    }
  };

  const onClearImageLink = () => {
    setImagePath(undefined);
  };

  const onAccessFileLink = () => {
    const _imageUrl = imageUrl || PUBLIC_BUCKET + imagePath;
    window.open(_imageUrl, '_blank');
  };

  return (
    <Components.UploadFileWrapper>
      <Components.InputMenu type='file' accept={'image/*'} id={id} onChange={selectHandlerForImageFile} />
      <ProjectTextField value={imagePath || ''} disabled placeholder={'No image path'} />
      {imagePath ? (
        <>
          <Components.IconWrapper onClick={() => onAccessFileLink()}>
            <AccessLinkIcon />
          </Components.IconWrapper>
          <Components.ClearButton onClick={onClearImageLink}>Clear</Components.ClearButton>
        </>
      ) : (
        <Components.UploadButton htmlFor={id}>
          {typeof imageUploadProgress === 'number' ? `${imageUploadProgress}%` : 'Upload Image'}
        </Components.UploadButton>
      )}
    </Components.UploadFileWrapper>
  );
};

export default ProjectImageField;
